import { zonedTimeToUtc, utcToZonedTime } from '@adsk/date-fns-tz';

import { DatePickerDate } from '../types';

/**
 * Takes number or Date representation of date/time in current timezone, convert it to a Date, in the new timeZone (if provided)
 */
export default ({
  date,
  timeZone,
}: {
  date: DatePickerDate;
  timeZone?: string;
}): Date => {
  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const utcTime = zonedTimeToUtc(date, currentTimeZone);

  const normalizedDate = utcToZonedTime(utcTime, timeZone ?? currentTimeZone);

  return normalizedDate;
};
